import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DealerDataService } from '../../dealer-data.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'ade-artigo',
  templateUrl: './artigo.component.html',
  styleUrls: ['./artigo.component.scss'],
})
export class AdeArtigoComponent implements OnInit, OnDestroy {
  article: any;
  isLoading = true;
  private _unsub = new Subject<void>();

  constructor(
    private _route: ActivatedRoute,
    private _svc: DealerDataService,
  ) {}

  ngOnInit(): void {
    const slug = this._route.snapshot.paramMap.get('slug');
    if (slug) {
      this._svc
        .getArticleBySlug(slug)
        .pipe(takeUntil(this._unsub))
        .subscribe((r: any) => {
          this.article = Array.isArray(r?.data) ? r.data[0] : r?.data;
          this.isLoading = false;
        });
    }
  }
  ngOnDestroy(): void {
    this._unsub.next();
    this._unsub.complete();
  }

  get a(): any {
    return this.article?.attributes ?? {};
  }

  featureImgUrl(url: string): string {
    if (!url) return '';
    return url.startsWith('http') ? url : `${environment.assets}${url}`;
  }
}
